import { OAuthService } from 'angular-oauth2-oidc';
import { Component, ViewChild, OnInit, HostListener } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavService, BhModalService } from 'bh-theme';
import { NAV_MENU_ITEMS } from './shared/constants/nav-menu-items';
import { AuthConfigService } from './modules/auth/auth-config.service';
import { AppConfigService } from './app-config/app-config.service';
import { AccessControlService } from './services/access-control.service';
import { PermissionService } from './shared/services/permission.service';
import { Router } from '@angular/router';
import { AssetTreeService } from './services/asset-tree.service';
import { DeviceInfoService } from './services/device-info.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Edge Hub';
  @ViewChild('appDrawer') appDrawer: MatSidenav;
  @ViewChild('assetTreeNav') assetTreeNav: MatSidenav;

  isSideNav: boolean = true;
  isAssetTreeOpen: boolean = true;
  isMenuOpen = true;
  profileDetails: any;
  permissionDetails: any[] = [];
  // side nav
  navItems: any[] = NAV_MENU_ITEMS;
  mobileMenuData: any;
  verisonText: string;
  permissions:any;
  showLoader = true;
  constructor(
    private readonly oauthService: OAuthService,
    private navService: NavService,
    private _bhModalService: BhModalService,
    private authConfigService: AuthConfigService,
    private appConfigService: AppConfigService,
    private _accessControlService: AccessControlService,
    private permissionService : PermissionService,
    private router: Router,
    private assetTreeService: AssetTreeService,
    public deviceInfoService: DeviceInfoService
  ) { }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setDynamicHeightForTheContentWindow()
  }

  ngOnInit() {
    this.assetTreeService.getShowAssetTreeNav().subscribe(
     (res:any) => {
      if( res  !== '' ){
        if (typeof res === 'string' || res instanceof String){
          this.isAssetTreeOpen = JSON.parse(res?.toLowerCase())
          this.toggleSidenav();
        }
        else{
        //  if(window.location.pathname.includes('/dashboard') ){
        //   this.isAssetTreeOpen = res;
        //  }
        //  else{
        //   this.isAssetTreeOpen = false;
        //  }
          this.isAssetTreeOpen = res;
        }
        
      }
    });

    this.verisonText = this.appConfigService.getConfig().versionText;
    let tokenPayload = this.authConfigService.getSessionStorage();
    if (tokenPayload) {
      this.setProfileDetails(tokenPayload);
      this.getPermissionDetails(tokenPayload['sub']);
      this.setMobileMenu();
      if(tokenPayload['uid']?.trim()!==this.authConfigService.getLastLoggedUser()?.trim()){
        this.router.navigate(['']);
      }
    } else {
      this.authConfigService.getTokenDetails().subscribe((payload: any) => {
        this.setProfileDetails(payload);
        this.setMobileMenu();
      })
    }

    setTimeout(() => {
      if (this.appDrawer) {
        this.navService.appDrawer = this.appDrawer;
        this.appDrawer.opened = (this.getSavedStateForMatDrawer() === 'true');
      }
      this.setDynamicHeightForTheContentWindow();
    }, 0);
  }


  setProfileDetails(payload) {
    this.profileDetails = {
      profileFirstName: payload ? payload.firstName  : '',
      profileLastName: '',
      logoutUrl: '/',
      profileMenuItems: []
    };

    this.saveMatDrawerStateLocally();
  }

  setMobileMenu() {
    this.mobileMenuData = {
      profileFirstName: this.profileDetails.profileFirstName,
      profileLastName: '',
      logoutUrl: this.profileDetails.logoutUrl,
      mobileMenuItems: [
        { subTitle: "Menu", navList: this.navItems },
        { subTitle: "Settings", navList: this.profileDetails.profileMenuItems }
      ]
    };
  }

  getPermissionDetails = (id: string) => {
    this._accessControlService.getPermissionsByUserName(id).subscribe((data) => {
      if (data) {
        this.permissionDetails = data;
        this.permissionService.setPermissions(data);
        let isSuperAdmin = data.filter(item=>item.name === 'edit-device')[0]?.allow;
        this.permissionService.setIsSuperAdmin(isSuperAdmin);
        this.permissions=data;
      } else {
        this.permissionDetails = [];
      }
    }, error => {
      console.log(error);
    });
  }

  ngAfterViewInit(): void {
    if (this.appDrawer) {
      this.navService.appDrawer = this.appDrawer;
      this.appDrawer.opened = (this.getSavedStateForMatDrawer() === 'true');
    }

  }
  toggleSidenav() {
    
    if(this.navService.currentUrl.value === '/dashboard'){
      this.isAssetTreeOpen = this.appDrawer.opened;
      this.assetTreeService.selectedOrgName = '';
    }
    
    this.navService.toggle();
    this.saveMatDrawerStateLocally(this.appDrawer.opened.toString());
    this.assetTreeService.sideNavOpen = this.appDrawer.opened;
    if(this.appDrawer.opened){
      this.assetTreeService.setShowAssetTreeNav(false);
    }
    else{
      this.assetTreeService.setShowAssetTreeNav(true);
    }
  }
  toggleMobileMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  navigationSelected() {
    this.isMenuOpen = false;
  }

  openTermsModal() {
    this._bhModalService.openModal(
      'Content for terms and conditions',
      this.closeOpenModal.bind(this),
      'Headline'
    );
  }

  openPrivacyNoticeModal() {
    this._bhModalService.openModal(
      'Content for privacy notice',
      this.closeOpenModal.bind(this),
      'Headline'
    );
  }

  closeOpenModal() {
    this._bhModalService.closeModal();
  }

  /**
   * Save mat drawer state locally
   * @param state 
   */
  saveMatDrawerStateLocally(state?: string) {
    if (this.getSavedStateForMatDrawer() === null) { // First time 
      localStorage.setItem(this.drawerKey(), 'false');
    } else {
      if (state)
        localStorage.setItem(this.drawerKey(), state);
    }
  }

  /**
   * Get mat drawer state fro local storage
   * @returns 
   */
  getSavedStateForMatDrawer(): string {
    return localStorage.getItem(this.drawerKey());
  }

  /**
   * Mat drawer key
   * @returns 
   */
  drawerKey() {
    return this.profileDetails.profileFirstName.toLowerCase() + '_mat_drawer_opened';
  }

  navParentMenuClicked(event: any) {
    let isOpened = (this.getSavedStateForMatDrawer() === "true");
    if (!isOpened) {
      this.navService.toggle();
      this.assetTreeService.sideNavOpen = true;
      this.saveMatDrawerStateLocally("true");
    }
  }

  setDynamicHeightForTheContentWindow() {
    const windowHeight = window.innerHeight;
    const headerHeight = document.querySelector(".header-row")['offsetHeight'];
    const footerHeight = document.querySelector(".footer")['offsetHeight'];
    const expectedHeightForPageContainer = windowHeight - (headerHeight + footerHeight);
    document.querySelector('.pages-container')['style'].minHeight = expectedHeightForPageContainer + 'px';
  }


}